module.exports = __webpack_public_path__ + "img/logo_fangci.962a2c59.png";